import axios from './../../libs/api.request'

export function querySkuRechargeList (data) {
  return axios.request({
    url: '/order/sku/account/record',
    method: 'post',
    data
  })
}

export function queryOrderList (data) {
  return axios.request({
    url: '/order/record',
    method: 'post',
    data
  })
}

export function update (data) {
  return axios.request({
    url: '/customer/update',
    method: 'post',
    data
  })
}

export function queryCustomer (data) {
  return axios.request({
    url: '/customer/list',
    method: 'post',
    data
  })
}

export function operationByPath (path) {
  return axios.request({
    url: path,
    method: 'get'
  })
}

export function deleteByIds (data) {
  return axios.request({
    url: '/customer/deleteByIds',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/components/order/orderApi.js